import { Cookies } from 'react-cookie';

import { MyClientProvider } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getInfoPestCompany = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('service-provider/my/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as MyClientProvider;
};
